module.exports = __webpack_public_path__ + "static/media/20170806_42day_2016AT.ec4d2acc.jpg";